<template>
  <div class="rounded max-w-lg">
    <div class="pb-5">
      <img
        :class="left?'ml-5 -mt-5':'mr-5 -ml-5 -mt-5'"
        class="rounded"
        :src="imgSrc"
        alt="featured-img"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GradientImage',
  props: {
    left: Boolean,
    imgSrc: {
      type: String,
      default: '//summitproedu.imgix.net/landing-pages/pt-phippf.jpg?auto=enhance&fit=crop,faces',
    },
  },
  computed: {
    gradientClass() {
      return this.$route.path.includes('/group-sales/setting') ? 'from-primary-140 to-primary-05' : 'from-primary to-primary-140';
    },
  },
};
</script>
